import React from 'react';
import type { TeamMember } from '../data/team';
interface TeamMemberCardProps {
  member: TeamMember;
}

/** Text-only team entry: initials, name and role. */
export function TeamMemberCard({
  member
}: TeamMemberCardProps) {
  return <div className="flex h-full items-center gap-4 rounded-2xl border border-line bg-white p-5" data-id="element-272" data-mp="xblyv9eb1ogw">
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary-soft font-display text-base font-semibold text-primary-dark" aria-hidden="true" data-id="element-273" data-mp="125ghe9i6bxee">
        {initials(member.name)}
      </span>
      <div className="min-w-0" data-id="element-274" data-mp="1h1fq9md3y1kl">
        <p className="font-display text-[17px] font-semibold leading-snug text-ink" data-id="element-275" data-mp="1h2hc8lvnw8h3">{member.name}</p>
        <p className="mt-0.5 text-sm text-muted" data-id="element-276" data-mp="1l1gefyq0dr4u">{member.role}</p>
      </div>
    </div>;
}
function initials(name: string) {
  const parts = name.replace(/^Drs\.\s*/, '').split(/\s+/);
  const last = parts[parts.length - 1].replace(/-.*/, '');
  return `${parts[0][0]}${last[0]}`.toUpperCase();
}